const BubbleContainer = (props) => {
    const { children } = props;
    const containerStyle = "max-w-xxs mid:max-w-md xxl:max-w-md relative flex flex-col items-stretch text-left";

    return <div className={containerStyle}>{children}</div>;
};

export default BubbleContainer;
